<template>
  <div
    v-show="offers.length"
    class="relative z-90 flex cursor-pointer justify-end transition-all"
  >
    <delete-offer-modal
      v-if="showDeleteOfferModal"
      :offers="offers"
      :close="() => (showDeleteOfferModal = false)"
      @offer-deleted="$emit('offerDeleted')"
    />
    <div
      class="absolute -top-4 -right-4 z-10 flex min-w-max -translate-y-full transform flex-col items-center"
      :class="[showTooltip ? 'visible' : 'invisible']"
    >
      <span
        class="whitespace-no-wrap relative rounded-lg bg-gray-800 p-2 pb-4 text-s leading-relaxed font-light text-white shadow-lg"
      >
        {{ toolTipText }}
      </span>
      <div class="z-20 -mt-2 h-3 w-3 rotate-45 transform bg-gray-800"></div>
    </div>
    <div
      class="flex rounded-sm border bg-red-500 py-3 pr-10 pl-4 text-white"
      @click="showDeleteOfferModal = true"
      @mouseenter="showTooltip = true"
      @mouseleave="showTooltip = false"
    >
      <icon-base :icon="IconDeleteOffer" />
      <span
        class="absolute ml-6 flex h-5 w-5 items-center justify-center rounded-full bg-gray-200/50 text-xxs"
      >
        {{ offers.length }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import IconDeleteOffer from "@/components/icons/IconDeleteOffer.vue";
import DeleteOfferModal from "@/views/deals/modals/DeleteOfferModal.vue";

import type { IOffer } from "@/models/funders";
import type { PropType } from "vue";

const props = defineProps({
  offers: {
    type: Array as PropType<IOffer[]>,
    default: () => [],
  },
  isSelfFunding: {
    type: Boolean,
    default: false,
  },
});

defineEmits<{
  offerDeleted: [void];
}>();

const showTooltip = ref(false);
const showDeleteOfferModal = ref(false);

const toolTipText = computed(() =>
  props.offers.length === 1
    ? "Delete Offer"
    : `Delete ${props.offers.length} offers`
);
</script>
